import { enrichImageObject } from './encoding-helpers';
import { capFirstChar } from './string-helpers-client.js';

const DEFAULT_COLOR_PRIMARY = '#868E96';
const DEFAULT_COLOR_SECONDARY = '#E4B21A';
const DEFAULT_OVERLAY_OPACITY = 0.5;
const DEFAULT_BANNER_OPACITY = 0.5;
const DEFAULT_TEXT_COLOR_PRIMARY = '#212529';
const DEFAULT_TEXT_COLOR_SECONDARY = '#212529';
const TEXT_COLORS = {
  white: '#ffffff',
  black: '#212529',
};

import {
  guildVisibilityMap, guildActivationStatusMap, guildStatusMap,
} from '../models/guild-client-enums.js';


export const enrichGuild = (guild) => {
  if (!guild || guild.isEnriched) return guild;

  const visibilitySettings = guildVisibilityMap[guild.visibility] || {};
  const statusSettings = guildStatusMap[guild.status] || {};
  const activationStatusSettings = guildActivationStatusMap[guild.activationStatus] || {};
  
  Object.assign(guild, {
    isEnriched: true,
    detailViewPath: `/${guild.key}`,
    ref: `guilds/${guild.id}`,

    avatar_icon: 'hive',
    avatar_shape: 'circle',
    avatar: enrichImageObject(guild.avatar),
    banner: enrichImageObject(guild.banner),

    colorPrimary: guild.colorPrimary || DEFAULT_COLOR_PRIMARY,
    colorSecondary: guild.colorSecondary || DEFAULT_COLOR_SECONDARY,
    overlayOpacity: guild.overlayOpacity || DEFAULT_OVERLAY_OPACITY,
    bannerOpacity: guild.bannerOpacity || DEFAULT_BANNER_OPACITY,
    
    textColorPrimary_hex: TEXT_COLORS[guild.textColorPrimary] || DEFAULT_TEXT_COLOR_PRIMARY,
    textColorSecondary_hex: TEXT_COLORS[guild.textColorSecondary] || DEFAULT_TEXT_COLOR_SECONDARY,
    textColorPrimary_isWhite: guild.textColorPrimary === 'white',
    textColorSecondary_isWhite: guild.textColorSecondary === 'white',

    visibility_label: visibilitySettings?.label || 'Unknown',
    visibility_description: visibilitySettings?.description || '',
    visibility_icon: visibilitySettings?.icon || 'help',

    status_label: statusSettings?.label || 'Unknown',
    status_description: statusSettings?.description || '',
    status_icon: statusSettings?.icon || 'help',
    status_iconLibrary: statusSettings?.iconLibrary || 'material',
    status_tagVariant: statusSettings?.tagVariant || 'default',

    activationStatus_label: activationStatusSettings?.label || 'Unknown',
    activationStatus_description: activationStatusSettings?.description || '',
    activationStatus_organizerNotes: activationStatusSettings?.organizerNotes || '',
    activationStatus_icon: activationStatusSettings?.icon || 'help',
    activationStatus_iconLibrary: activationStatusSettings?.iconLibrary || 'material',
    activationStatus_tagVariant: activationStatusSettings?.tagVariant || 'default',
  });

  return guild;
}
